<div class="grid" >
  <ng-template [ngIf]="isLoading">
      <app-loading [contesto]="'DASHBOARD'"></app-loading>
  </ng-template>
  <div class="col-12 p-2 text-xl text-left font-['Poppins']" style="color: cadetblue; display: flex; justify-content: space-between; align-items: center;">
    <div style="display: flex; align-items: center; gap: 10px;">
        <span class="text-xl text-left font-['Poppins'] mr-3 font-semibold" style="color: cadetblue;">Pratiche Bando 1</span>
        <div class="p-2" style="border-radius: 10px; background-color: #619496; display: flex; justify-content: center; align-items: center; height: 100%;">
          <span class="text-right font-['Poppins']" style="color: #f9f9f9; font-size: small;">Totali: <span class="font-semibold" style="font-size: medium;">{{this.stats.bando1Totali}}</span></span>
        </div>
        <div class="p-2" style="border-radius: 10px; background-color: #e3b23e; display: flex; justify-content: center; align-items: center; height: 100%;">
          <span class="text-right font-['Poppins']" style="color: #ffffff; font-size: small;">In lavorazione: <span class="font-semibold" style="font-size: medium;">{{this.stats.bando1InLavorazione}}</span></span>
       </div>
       <span class="p-input-icon-left mr-2" style="border-radius: 10px;">
        <i *ngIf="!filtroBando1"  class="pi pi-search"></i>
        <i *ngIf="filtroBando1"   class="pi pi-times cursor-pointer" (click)="clearFiltroBando1()"  pTooltip="Pulisci" tooltipPosition="left"></i>
        <input type="text" pInputText placeholder="Cerca per singolo CUIN" (input)="filtraPraticheBando1($event)" [value]="filtroBando1" [disabled]="isLoading" style="height: 2.5rem; width: 300px; border-color: #ccc;" [ngStyle]="{'border-color': filtroBando1 ? 'cadetblue' : '#ccc'}" />
      </span>
    </div>
    <div>
   
    <!--   <button 
        pButton type="button" icon="pi pi-sync"
        pTooltip="Esporta il report" tooltipPosition="top"
        class="font-['Poppins'] mr-3"
        style="background-color:#ffffff; color: #3d64b3; border-color: #3d64b3; font-size: 13px;"
        (click)="allineaBando1()"
      ></button> -->
    <button *ngIf="!isPM"
      pButton type="button" icon="pi pi-cloud-download"
      pTooltip="Esporta il report" tooltipPosition="top"
      class="font-['Poppins'] mr-3"
      style="background-color:#ffffff; color: #3d64b3; border-color: #3d64b3; font-size: 13px;"
      label="REPORT"
      (click)="scaricaReportPraticheBando1()" [disabled]="isLoadingResults"
    ></button>
    <button *ngIf="!isPM && !isImpresa"
      pButton type="button" icon="pi pi-cloud-download"
      pTooltip="Esporta l'anagrafica delle pratiche di BANDO 1" tooltipPosition="top"
      class="font-['Poppins'] mr-3"
      style="background-color:#ffffff; color: #1b463e; border-color: #1b463e; font-size: 13px;"
      label="ANAGRAFICA"
      (click)="scaricaAnagraficaPraticheBando1()" [disabled]="isLoadingResults"
    ></button>
      <button *ngIf="isPresidioSF" pButton type="button" icon="pi pi-file-import" 
        pTooltip="Aggiorna pratiche del BANDO 1"
            tooltipPosition="top" class="font-['Poppins'] mr-3"
            style="background-color:#ffffff; color: cadetblue; border-color: cadetblue; font-size: 13px;"
            label="AGGIORNA" (click)="aggiornaPratiche(1)" [disabled]="isLoading">
        </button>
       <!--  <button *ngIf="isPresidioSF" pButton type="button" icon="pi pi-file-import" 
        pTooltip="Carica codice a barre"
        tooltipPosition="top" class="font-['Poppins'] mr-3"
        style="background-color:#ffffff; color: cadetblue; border-color: cadetblue; font-size: 13px;"
        label="CARICA CODICE A BARRE" (click)="caricaCodiceBarre()" [disabled]="isLoading">
        </button> -->
       <!--   <button *ngIf="isPresidioSF" pButton type="button" icon="pi pi-file-import" 
            pTooltip="Check pratiche"
            tooltipPosition="top" class="font-['Poppins'] mr-3"
            style="background-color:#ffffff; color: rgb(86, 56, 157); border-color: cadetblue; font-size: 13px;"
            label="CHECK" (click)="checkPratiche()" [disabled]="isLoading">
        </button>  
        -->
      <button *ngIf="isPresidioSF" pButton type="button" icon="pi pi-file-import" 
        pTooltip="Aggiorna CONTABILE del BANDO 1"
            tooltipPosition="top" class="font-['Poppins'] mr-3"
            style="background-color:#ffffff; color: rgb(86, 56, 157); border-color: cadetblue; font-size: 13px;"
            label="CONTABILE" (click)="aggiornaContabile(1)" [disabled]="isLoading">
        </button>
      <!-- <button *ngIf="!isImpresa"
          pButton type="button" icon="pi pi-file-import"
          pTooltip="Aggiorna pratiche" tooltipPosition="top"
          class="font-['Poppins'] mr-3"
          style="background-color:#ffffff; color: cadetblue; border-color: cadetblue; font-size: 13px;"
          label="Aggiorna pratiche"
          (click)="aggiornaPratiche(1)" [disabled]="isLoading"
      ></button>
      <button *ngIf="!isImpresa"
          pButton type="button" icon="pi pi-reply"
          pTooltip="Carica gli esiti della consegna ad Infratel" tooltipPosition="top"
          class="font-['Poppins'] "
          style="background-color:#ffffff; color: cadetblue; border-color: cadetblue; font-size: 13px;"
          label="Carica Esiti"
          (click)="aggiornaPratiche(1)" [disabled]="isLoading"
      ></button> -->
    </div>
    
  </div>
  <div class="col-12 grid mt-1 mb-1">
      <div class="col">
        <div class="p-3" style="border-radius: 17px; background-color: #F3F9F9; text-align: right;">
          <div style="display: flex; justify-content: space-between; align-items: top;">
              <div class="font-semibold font-['Poppins']" style="color: #478484; ">FASE I</div>
              <i class="pi pi-eye" style="font-size: 2rem; cursor: pointer; color: #478484;"
                (click)="openPraticheBando(1,'fase-1')" 
                [pTooltip]="isFilteringBando1 && praticheFiltrateBando1?.length === 1 ? 'Apri la pratica di fase I' : 'Apri Pratiche Fase I'"
                tooltipPosition="top"></i>
          </div>
          <!--
          
          [style.pointer-events]="(isFilteringBando1 && praticheFiltrateBando1.length > 1) || (!isFilteringBando1 && stats.bando1Fase1 == 0) ? 'none' : 'auto'"
                [style.opacity]="(isFilteringBando1 && praticheFiltrateBando1.length > 1) || (!isFilteringBando1 && stats.bando1Fase1 == 0) ? '0.5' : '1'"
                -->
          <div class="text-3xl font-['Poppins']" style="font-weight: bold; text-align: left; color: #478484">{{this.stats.bando1Fase1}}</div>
            <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
              <p-tag [style]="{ 'background': '#F5F5F5', 'color':'#478484', 'margin-bottom': '0.3rem' }" >
                <div style="cursor: pointer;" (click)="openPraticheBandoPerLotto(1,'fase-1','6')" pTooltip="Apri pratiche lotto 6" tooltipPosition="top">LOTTO 6: <span class="text-l">{{this.stats.bando1Fase1_lotto6}}</span></div>
          <!--      <div style="cursor: pointer; font-size: 11px;" (click)="openPraticheBandoPerLotto(1,'fase-1','6')" pTooltip="Apri pratiche lotto 6" tooltipPosition="top">SOPRALLUOGHI DA PIANIFICARE: <span style="font-size: 13px;">{{this.stats.bando1Fase1_sopralluogo_da_pianificare}}</span></div>-->  
              </p-tag>
              <p-tag [style]="{ 'background': '#F5F5F5', 'color':'#478484', 'margin-bottom': '0.3rem'  }" >
                <div style="cursor: pointer;" (click)="openPraticheBandoPerLotto(1,'fase-1','7')" pTooltip="Apri pratiche lotto 7" tooltipPosition="top">LOTTO 7: <span class="text-l">{{this.stats.bando1Fase1_lotto7}}</span></div>
           <!--     <div style="cursor: pointer; font-size: 11px;" (click)="openPraticheBandoPerLotto(1,'fase-1','7')" pTooltip="Apri pratiche lotto 7" tooltipPosition="top">SOPRALLUOGHI PIANIFICATI: <span style="font-size: 13px;">{{this.stats.bando1Fase1_sopralluogo_pianificato}}</span></div>-->
              </p-tag>
              <!-- <p-tag [style]="{ 'background': '#F5F5F5', 'color':'#478484' }" >
                <div style="cursor: pointer; font-size: 11px;" (click)="openPraticheBandoPerLotto(1,'fase-1','7')" pTooltip="Apri pratiche lotto 7" tooltipPosition="top">SOPRALLUOGHI OK: <span style="font-size: 13px;">{{this.stats.bando1Fase1_sopralluogo_effettuato}}</span></div>
              </p-tag> -->
            </div>
        </div>
      </div>
      <div class="col">
        <div class="p-3" style="border-radius: 17px; background-color: #E7F2F2; text-align: right;">
          <div style="display: flex; justify-content: space-between; align-items: top;">
            <div class="font-semibold font-['Poppins']" style="color: #478484; " >PRONTOFIBRA</div>
            <i class="material-symbols-outlined" style="font-size: 2rem; cursor: pointer; color: #478484" (click)="openPraticheBando(1,'PF')" pTooltip="Apri ProntoFibra">cable</i>
          </div>
          <div class="text-3xl font-['Poppins']" style="font-weight: bold; text-align: left; color: #478484" tooltipPosition="left" pTooltip="Il totale comprende tutti i PF in stato diverso da IN ATTESA">{{this.stats.prontofibraBando1}}</div>
          <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
            <p-tag [style]="{ 'background': '#e1ebf0', 'color':'#478484', 'margin-bottom': '0.5rem' }" >
              <div style="cursor: pointer;" pTooltip="Apri prontofibra lotto 6" (click)="openPraticheBandoPerLotto(1,'PF','6')" tooltipPosition="top">LOTTO 6: <span class="text-l">{{this.stats.prontofibraBando1_lotto6}}</span></div>
            </p-tag>
            <p-tag [style]="{ 'background': '#e1ebf0', 'color':'#478484' }" >
              <div style="cursor: pointer;" pTooltip="Apri prontofibra lotto 7" (click)="openPraticheBandoPerLotto(1,'PF','7')" tooltipPosition="top">LOTTO 7: <span class="text-l">{{this.stats.prontofibraBando1_lotto7}}</span></div>
            </p-tag>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="p-3" style="border-radius: 17px; background-color: #D6E9E9; text-align: right;">
          <div style="display: flex; justify-content: space-between; align-items: top;">
            <div class="font-semibold font-['Poppins']" style="color: #478484;"> FASE II</div>
            <i class="material-symbols-outlined" style="font-size: 2rem; cursor: pointer; color: #478484"  (click)="openPraticheBando(1,'fase-2')" pTooltip="Apri Pratiche Fase II">router</i>
          </div>
          
          <div class="text-3xl font-['Poppins']" style="font-weight: bold; text-align: left; color: #478484">{{this.stats.bando1Fase2}}</div>
          <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
            <p-tag [style]="{ 'background': '#cee4ed', 'color':'#478484', 'margin-bottom': '0.5rem' }" >
              <div style="cursor: pointer;" (click)="openPraticheBandoPerLotto(1,'fase-2','6')"  pTooltip="Apri pratiche lotto 6" tooltipPosition="top">LOTTO 6: <span class="text-l">{{this.stats.bando1Fase2_lotto6}}</span></div>
            </p-tag>
            <p-tag [style]="{ 'background': '#cee4ed', 'color':'#478484' }" >
              <div style="cursor: pointer;" (click)="openPraticheBandoPerLotto(1,'fase-2','7')"  pTooltip="Apri pratiche lotto 7" tooltipPosition="top">LOTTO 7: <span class="text-l">{{this.stats.bando1Fase2_lotto7}}</span></div>
            </p-tag>
          </div>
        </div>
        
      </div>
      <div class="col">
        <div class="p-3" style="border-radius: 17px; background-color: #C4DFDF; text-align: right;">
          <div style="display: flex; justify-content: space-between; align-items: top;">
            <div class="font-semibold font-['Poppins']" style="color: #478484;"> FASE III</div>
            <i class="material-symbols-outlined" style="font-size: 2rem; cursor: pointer; color: #478484"
            (click)="openPraticheBando(1,'fase-3')" pTooltip="Apri Pratiche Fase III">draw</i>
          </div>
          
          <div class="text-3xl font-['Poppins']" style="font-weight: bold; text-align: left; color: #478484">{{this.stats.bando1Fase3}}</div>
          <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
            <p-tag [style]="{ 'background': '#cddde3', 'color':'#478484', 'margin-bottom': '0.5rem' }" >
              <div style="cursor: pointer;" (click)="openPraticheBandoPerLotto(1,'fase-3','6')" pTooltip="Apri pratiche lotto 6" tooltipPosition="top">LOTTO 6: <span class="text-l">{{this.stats.bando1Fase3_lotto6}}</span></div>
            </p-tag>
            <p-tag [style]="{ 'background': '#cddde3', 'color':'#478484' }" >
              <div style="cursor: pointer;" (click)="openPraticheBandoPerLotto(1,'fase-3','7')" pTooltip="Apri pratiche lotto 7" tooltipPosition="top">LOTTO 7: <span class="text-l">{{this.stats.bando1Fase3_lotto7}}</span></div>
            </p-tag>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="p-3" style="border-radius: 17px; background-color: #E9E9E9; text-align: right;">
          <div style="display: flex; justify-content: space-between; align-items: top;">
            <div class="font-semibold font-['Poppins']" style="color: #606060; ">KO</div>
            <i class="material-symbols-outlined" style="font-size: 2rem; cursor: pointer; color: #606060" (click)="openPraticheBando(1,'ko')" 
            pTooltip="Apri Pratiche KO" tooltipPosition="top">cancel</i>
          </div>
          <div class="text-3xl font-['Poppins']" style="font-weight: bold; text-align: left; color: #606060">{{this.stats.bando1KO}}</div>
          <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
            <p-tag [style]="{ 'background': '#E1DFDF', 'color':'#606060', 'margin-bottom': '0.5rem' }" >
              <div style="cursor: pointer;" (click)="openPraticheBandoPerLotto(1,'ko','6')" pTooltip="Apri pratiche lotto 6" tooltipPosition="top">LOTTO 6: <span class="text-l">{{this.stats.bando1KO_lotto6}}</span></div>
            </p-tag>
            <p-tag [style]="{ 'background': '#E1DFDF', 'color':'#606060' }" >
              <div style="cursor: pointer;" (click)="openPraticheBandoPerLotto(1,'ko','7')" pTooltip="Apri pratiche lotto 7" tooltipPosition="top">LOTTO 7: <span class="text-l">{{this.stats.bando1KO_lotto7}}</span></div>
            </p-tag>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 border-bottom-1 opacity-50 "></div>

    <div class="col-12 mt-2 p-2 text-xl text-left font-['Poppins']" style="color: cornflowerblue; display: flex; justify-content: space-between; align-items: center;">
      <div style="display: flex; align-items: center; gap: 10px;">
        <span class="text-xl text-left font-['Poppins'] mr-3 font-semibold" style="color: cornflowerblue;">Pratiche Bando 2</span>
        <div class="p-2" style="border-radius: 10px; background-color: #86a5e0; display: flex; justify-content: center; align-items: center; height: 100%;">
          <span class="text-right font-['Poppins']" style="color: #f9f9f9; font-size: small;">Totali: <span class="font-semibold" style="font-size: medium;">{{this.stats.bando2Totali}}</span></span>
        </div>
        <div class="p-2" style="border-radius: 10px; background-color: #e3b23e; display: flex; justify-content: center; align-items: center; height: 100%;">
          <span class="text-right font-['Poppins']" style="color: #ffffff; font-size: small;">In lavorazione: <span class="font-semibold" style="font-size: medium;">{{this.stats.bando2InLavorazione}}</span></span>
       </div>
       <span  class="p-input-icon-left mr-2" style="border-radius: 10px;">
        <i *ngIf="!filtroBando2"  class="pi pi-search"></i>
        <i *ngIf="filtroBando2"   class="pi pi-times cursor-pointer" (click)="clearFiltroBando2()"  pTooltip="Pulisci" tooltipPosition="left"></i>
        <input type="text" pInputText placeholder="Cerca per singolo CUIN" (input)="filtraPraticheBando2($event)" [value]="filtroBando2" [disabled]="isLoading" style="height: 2.5rem; width: 300px; border-color: #ccc;" [ngStyle]="{'border-color': filtroBando2 ? 'cornflowerblue' : '#ccc'}" />
      </span>
      </div>
      <div>
       
     
    <!--   <button 
      pButton type="button" icon="pi pi-sync"
      pTooltip="Esporta il report" tooltipPosition="top"
      class="font-['Poppins'] mr-3"
      style="background-color:#ffffff; color: #3d64b3; border-color: #3d64b3; font-size: 13px;"
      (click)="allineaBando2()"
    ></button> -->
      <button *ngIf="!isPM "
      pButton type="button" icon="pi pi-cloud-download"
      pTooltip="Esporta il report" tooltipPosition="top"
      class="font-['Poppins'] mr-3"
      style="background-color:#ffffff; color: #3d64b3; border-color: #3d64b3; font-size: 13px;"
      label="REPORT"
      (click)="scaricaReportPraticheBando2()" [disabled]="isLoadingResults"
    ></button>
    <button *ngIf="!isPM && !isImpresa"
      pButton type="button" icon="pi pi-cloud-download"
      pTooltip="Esporta l'anagrafica delle pratiche di BANDO 2" tooltipPosition="top"
      class="font-['Poppins'] mr-3"
      style="background-color:#ffffff; color: #1b463e; border-color: #1b463e; font-size: 13px;"
      label="ANAG."
      (click)="scaricaAnagraficaPraticheBando2()" [disabled]="isLoadingResults"
    ></button>
    <button *ngIf="!isPM && !isImpresa && !isPresidioTIM"
      pButton type="button" icon="pi pi-cloud-download"
      pTooltip=" Report Preventivi Opere Extra" tooltipPosition="top"
      class="font-['Poppins'] mr-3"
      style="background-color:#ffffff; color: #270a66; border-color: #270a66; font-size: 13px;"
      label="PREV. O.E."
      (click)="scaricaReportPreventiviOpereExtra()" [disabled]="isLoadingResults"
    ></button>
  <!--   <button *ngIf="!isPM && !isImpresa && !isPresidioTIM"
      pButton type="button" icon="pi pi-file-import"
      pTooltip="Aggiorna Situazione OF" tooltipPosition="top"
      class="font-['Poppins'] mr-3"
      style="background-color:#ffffff; color: #270a66; border-color: #270a66; font-size: 13px;"
      label="OF"
      (click)="aggiornaSituazioneOF()" [disabled]="isLoadingResults"
    ></button> -->
      <button *ngIf="isPresidioSF" pButton type="button" icon="pi pi-file-import" pTooltip="Aggiorna pratiche del BANDO 2"
          tooltipPosition="top" class="font-['Poppins'] mr-3"
          style="background-color:#ffffff; color: cornflowerblue; border-color: cornflowerblue; font-size: 13px;"
          label="AGGIORNA" (click)="aggiornaPratiche(2)" [disabled]="isLoading">
      </button>
    <!--   <button *ngIf="isPresidioSF" pButton type="button" icon="pi pi-file-import" 
        pTooltip="Aggiorna CONTABILE del BANDO 2"
            tooltipPosition="top" class="font-['Poppins'] mr-3"
            style="background-color:#ffffff; color: rgb(86, 56, 157); border-color: cadetblue; font-size: 13px;"
            label="CONTABILE" (click)="aggiornaContabile(2)" [disabled]="isLoading">
        </button> -->
       <!--  <button *ngIf="!isImpresa"
            pButton type="button" icon="pi pi-file-edit"
            pTooltip="Aggiorna pratiche" tooltipPosition="top"
            class="font-['Poppins'] mr-3"
            style="background-color:#ffffff; color: cornflowerblue; border-color: cornflowerblue; font-size: 13px;"
            label="Aggiorna pratiche"
            (click)="aggiornaPratiche(2)" [disabled]="isLoading"
        ></button>
       
        <button
            pButton type="button" icon="pi pi-reply"
            pTooltip="Importa gli esiti delle pubblicazioni" tooltipPosition="top"
            class="font-['Poppins'] "
            style="background-color:#ffffff; color: cornflowerblue; border-color: cornflowerblue; font-size: 13px;"
            label="Carica Esiti"
            (click)="aggiornaPratiche(2)" [disabled]="isLoading"
        ></button> -->
      </div>
      
    </div>
    <div class="col-12 grid mt-1 mb-1">
      <div class="col">
        <div class="p-3" style="border-radius: 17px; background-color: #F2FDFD; text-align: right;">
          <div style="display: flex; justify-content: space-between; align-items: top;">
              <div class="font-semibold font-['Poppins']" style="color: #478484; ">FASE I</div>
              <i class="pi pi-eye" style="font-size: 2rem; cursor: pointer; color: #478484;"
                (click)="openPraticheBando(2,'fase-1')" pTooltip="Apri Pratiche Fase I"
                [style.pointer-events]="isLoading ? 'none' : 'auto'"
                [style.opacity]="isLoading ? '0.5' : '1'"></i>
          </div>
            <div class="text-3xl font-['Poppins']" style="font-weight: bold; text-align: left; color: #478484">{{this.stats.bando2Fase1}}</div>
            <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
             <!-- <p-tag [style]="{ 'background': '#F5F5F5', 'color':'#478484', 'margin-bottom': '0.3rem' }" >
                 <div style="cursor: pointer; font-size: 11px;" (click)="openPraticheBandoPerLotto(1,'fase-1','6')" pTooltip="Apri pratiche lotto 6" tooltipPosition="top">SOPRALLUOGHI DA PIANIFICARE: <span style="font-size: 13px;">{{this.stats.bando2Fase1_sopralluogo_da_pianificare}}</span></div>
              </p-tag>
              <p-tag [style]="{ 'background': '#F5F5F5', 'color':'#478484', 'margin-bottom': '0.3rem'  }" >
                <div style="cursor: pointer; font-size: 11px;" (click)="openPraticheBandoPerLotto(1,'fase-1','7')" pTooltip="Apri pratiche lotto 7" tooltipPosition="top">SOPRALLUOGHI PIANIFICATI: <span style="font-size: 13px;">{{this.stats.bando2Fase1_sopralluogo_pianificato}}</span></div>
              </p-tag>
              <p-tag [style]="{ 'background': '#F5F5F5', 'color':'#478484' }" >
                <div style="cursor: pointer; font-size: 11px;" (click)="openPraticheBandoPerLotto(1,'fase-1','7')" pTooltip="Apri pratiche lotto 7" tooltipPosition="top">SOPRALLUOGHI OK: <span style="font-size: 13px;">{{this.stats.bando2Fase1_sopralluogo_effettuato}}</span></div>
              </p-tag>-->
               <p-tag [style]="{ 'background': '#f3f7f9', 'color':'#478484', 'margin-bottom': '0.2rem' }" >
                <div style="cursor: pointer;" (click)="openPraticheBandoPerLotto(2,'fase-1','1')" pTooltip="Apri pratiche lotto 1" tooltipPosition="top">LOTTO 1: <span class="text-l">{{this.stats.bando2Fase1_lotto1}}</span></div>
              </p-tag>
              <p-tag [style]="{ 'background': '#f3f7f9', 'color':'#478484', 'margin-bottom': '0.2rem' }" >
                <div style="cursor: pointer;" (click)="openPraticheBandoPerLotto(2,'fase-1','5')" pTooltip="Apri pratiche lotto 5" tooltipPosition="top">LOTTO 5: <span class="text-l">{{this.stats.bando2Fase1_lotto5}}</span></div>
              </p-tag>
              <p-tag [style]="{ 'background': '#f3f7f9', 'color':'#478484','margin-bottom': '0.2rem' }" >
                <div style="cursor: pointer;" (click)="openPraticheBandoPerLotto(2,'fase-1','7')" pTooltip="Apri pratiche lotto 7" tooltipPosition="top">LOTTO 7: <span class="text-l">{{this.stats.bando2Fase1_lotto7}}</span></div>
              </p-tag>
              <p-tag [style]="{ 'background': '#f3f7f9', 'color':'#478484' }" >
                <div style="cursor: pointer;" (click)="openPraticheBandoPerLotto(2,'fase-1','8')" pTooltip="Apri pratiche lotto 8" tooltipPosition="top">LOTTO 8: <span class="text-l">{{this.stats.bando2Fase1_lotto8}}</span></div>
              </p-tag> 
            </div>
        </div>
      </div>
      <div class="col">
        <div class="p-3" style="border-radius: 17px; background-color: #E5FAFA; text-align: right;">
          <div style="display: flex; justify-content: space-between; align-items: top;">
            <div class="font-semibold font-['Poppins']" style="color: #478484;  ">PRONTOFIBRA</div>
            <i class="material-symbols-outlined" style="font-size: 2rem; cursor: pointer; color: #478484"
            (click)="openPraticheBando(2,'PF')" pTooltip="Apri ProntoFibra">cable</i>
          </div>
          
          <div class="text-3xl font-['Poppins']" style="font-weight: bold; text-align: left; color: #478484" tooltipPosition="left" pTooltip="Il totale comprende tutti i PF in stato diverso da IN ATTESA">{{this.stats.prontofibraBando2}}</div>
          <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
            <p-tag [style]="{ 'background': '#e5f0f5', 'color':'#478484', 'margin-bottom': '0.2rem' }" >
              <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 1" tooltipPosition="top" (click)="openPraticheBandoPerLotto(2,'PF','1')" >LOTTO 1: <span class="text-l">{{this.stats.prontofibraBando2_lotto1}}</span></div>
            </p-tag>
            <p-tag [style]="{ 'background': '#e5f0f5', 'color':'#478484', 'margin-bottom': '0.2rem' }" >
              <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 5" tooltipPosition="top" (click)="openPraticheBandoPerLotto(2,'PF','5')">LOTTO 5: <span class="text-l">{{this.stats.prontofibraBando2_lotto5}}</span></div>
            </p-tag>
            <p-tag [style]="{ 'background': '#e5f0f5', 'color':'#478484','margin-bottom': '0.2rem' }" >
              <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 7" tooltipPosition="top" (click)="openPraticheBandoPerLotto(2,'PF','7')">LOTTO 7: <span class="text-l">{{this.stats.prontofibraBando2_lotto7}}</span></div>
            </p-tag>
            <p-tag [style]="{ 'background': '#e5f0f5', 'color':'#478484' }" >
              <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 8" tooltipPosition="top" (click)="openPraticheBandoPerLotto(2,'PF','8')">LOTTO 8: <span class="text-l">{{this.stats.prontofibraBando2_lotto8}}</span></div>
            </p-tag>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="p-3" style="border-radius: 17px; background-color: #D1F7F7; text-align: right;">
          <div style="display: flex; justify-content: space-between; align-items: top;">
            <div class="font-semibold font-['Poppins']" style="color: #478484;"> FASE II</div>
            <i class="material-symbols-outlined" style="font-size: 2rem; cursor: pointer; color: #478484"  (click)="openPraticheBando(2,'fase-2')" pTooltip="Apri Pratiche Fase II">router</i>
          </div>
          
          <div class="text-3xl font-['Poppins']" style="font-weight: bold; text-align: left; color: #478484">{{this.stats.bando2Fase2}}</div>
          <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
            <p-tag [style]="{ 'background': '#d3efef', 'color':'#478484', 'margin-bottom': '0.2rem' }" >
              <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 1" tooltipPosition="top" (click)="openPraticheBandoPerLotto(2,'fase-2','1')">LOTTO 1: <span class="text-l">{{this.stats.bando2Fase2_lotto1}}</span></div>
            </p-tag>
            <p-tag [style]="{ 'background': '#d3efef', 'color':'#478484', 'margin-bottom': '0.2rem' }" >
              <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 5" tooltipPosition="top" (click)="openPraticheBandoPerLotto(2,'fase-2','5')">LOTTO 5: <span class="text-l">{{this.stats.bando2Fase2_lotto5}}</span></div>
            </p-tag>
            <p-tag [style]="{ 'background': '#d3efef', 'color':'#478484','margin-bottom': '0.2rem' }" >
              <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 7" tooltipPosition="top" (click)="openPraticheBandoPerLotto(2,'fase-2','7')">LOTTO 7: <span class="text-l">{{this.stats.bando2Fase2_lotto7}}</span></div>
            </p-tag>
            <p-tag [style]="{ 'background': '#d3efef', 'color':'#478484' }" >
              <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 8" tooltipPosition="top" (click)="openPraticheBandoPerLotto(2,'fase-2','8')">LOTTO 8: <span class="text-l">{{this.stats.bando2Fase2_lotto8}}</span></div>
            </p-tag>
          </div>
        </div>
        
      </div>
      <div class="col">
        <div class="p-3" style="border-radius: 17px; background-color: #BEF3F3; text-align: right;">
          <div style="display: flex; justify-content: space-between; align-items: top;">
            <div class="font-semibold font-['Poppins']" style="color: #478484;"> FASE III</div>
            <i class="material-symbols-outlined" style="font-size: 2rem; cursor: pointer; color: #478484"
            (click)="openPraticheBando(2,'fase-3')" pTooltip="Apri Pratiche Fase III">draw</i>
          </div>
          
          <div class="text-3xl font-['Poppins']" style="font-weight: bold; text-align: left; color: #478484">{{this.stats.bando2Fase3}}</div>
          <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
            <p-tag [style]="{ 'background': '#bedfdf', 'color':'#478484', 'margin-bottom': '0.2rem' }" >
              <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 1" tooltipPosition="top" (click)="openPraticheBandoPerLotto(2,'fase-3','1')">LOTTO 1: <span class="text-l">{{this.stats.bando2Fase3_lotto1}}</span></div>
            </p-tag>
            <p-tag [style]="{ 'background': '#bedfdf', 'color':'#478484', 'margin-bottom': '0.2rem' }" >
              <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 5" tooltipPosition="top" (click)="openPraticheBandoPerLotto(2,'fase-3','1')">LOTTO 5: <span class="text-l">{{this.stats.bando2Fase3_lotto5}}</span></div>
            </p-tag>
            <p-tag [style]="{ 'background': '#bedfdf', 'color':'#478484','margin-bottom': '0.2rem' }" >
              <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 7" tooltipPosition="top" (click)="openPraticheBandoPerLotto(2,'fase-3','1')">LOTTO 7: <span class="text-l">{{this.stats.bando2Fase3_lotto7}}</span></div>
            </p-tag>
            <p-tag [style]="{ 'background': '#bedfdf', 'color':'#478484' }" >
              <div style="cursor: pointer;" pTooltip="Apri pratiche lotto 8" tooltipPosition="top" (click)="openPraticheBandoPerLotto(2,'fase-3','1')">LOTTO 8: <span class="text-l">{{this.stats.bando2Fase1_lotto8}}</span></div>
            </p-tag>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="p-3" style="border-radius: 17px; background-color: #E9E9E9; text-align: right;">
          <div style="display: flex; justify-content: space-between; align-items: top;">
            <div class="font-semibold font-['Poppins']" style="color: #606060; ">KO</div>

            <i class="material-symbols-outlined" style="font-size: 2rem; cursor: pointer; color: #606060"
            (click)="openPraticheBando(2,'ko')" pTooltip="Apri Pratiche KO">cancel</i>
          </div>
          <div class="text-3xl font-['Poppins']" style="font-weight: bold; text-align: left; color: #606060">{{this.stats.bando2KO}}</div>
          <div class="mt-2" style="text-align: right; display: flex; flex-direction: column; justify-content: right;">
            <p-tag [style]="{ 'background': '#E1DFDF', 'color':'#606060', 'margin-bottom': '0.2rem' }" >
              <div style="cursor: pointer;" (click)="openPraticheBandoPerLotto(2,'ko','1')" pTooltip="Apri pratiche lotto 1" tooltipPosition="top">LOTTO 1: <span class="text-l">{{this.stats.bando2KO_lotto1}}</span></div>
            </p-tag>
            <p-tag [style]="{'background': '#E1DFDF', 'color':'#606060', 'margin-bottom': '0.2rem' }" >
              <div style="cursor: pointer;" (click)="openPraticheBandoPerLotto(2,'ko','5')" pTooltip="Apri pratiche lotto 5" tooltipPosition="top">LOTTO 5: <span class="text-l">{{this.stats.bando2KO_lotto5}}</span></div>
            </p-tag>
            <p-tag [style]="{ 'background': '#E1DFDF', 'color':'#606060','margin-bottom': '0.2rem' }" >
              <div style="cursor: pointer;" (click)="openPraticheBandoPerLotto(2,'ko','7')" pTooltip="Apri pratiche lotto 7" tooltipPosition="top">LOTTO 7: <span class="text-l">{{this.stats.bando2KO_lotto7}}</span></div>
            </p-tag>
            <p-tag [style]="{ 'background': '#E1DFDF', 'color':'#606060' }" >
              <div style="cursor: pointer;" (click)="openPraticheBandoPerLotto(2,'ko','8')"  pTooltip="Apri pratiche lotto 8" tooltipPosition="top">LOTTO 8: <span class="text-l">{{this.stats.bando2Fase1_lotto8}}</span></div>
            </p-tag>
          </div>
        </div>
      </div>
    </div>
</div>